import { FocusEventHandler, ForwardedRef, forwardRef, useCallback } from "react";
import { BaseTextFieldProps, FilledInputProps, TextField } from "@mui/material";
import { IMaskInput } from "react-imask";

export interface MaskedTextFieldProps extends BaseTextFieldProps {
  label?: string;
  mask: string;
  definitions?: { [key: string]: RegExp };
  hiddenLabel?: boolean;
  placeholder?: string;
  onChange?: (value: string) => void;
  onBlur?: FocusEventHandler<HTMLTextAreaElement | HTMLInputElement>;
  InputProps?: Partial<FilledInputProps>
}

const MaskedInput = forwardRef((props: any, ref: ForwardedRef<JSX.Element>) => {
  const { onChange, mask, definitions, value, ...rest } = props;
  return <IMaskInput {...rest} value={value} mask={mask} definitions={definitions} inputRef={ref} onAccept={onChange} unmask={true} />;
});

const MaskedTextField = ({ value, mask, definitions, onChange, placeholder, InputProps, ...rest }: MaskedTextFieldProps) => {
  const sendOnChange = useCallback(
    (value) => {
      if (onChange) {
        onChange(value.toUpperCase());
      }
    },
    [onChange]
  );

  return (
    <TextField
      {...rest}
      value={value}
      variant="filled"
      InputProps={{
        inputComponent: MaskedInput,
        inputProps: { mask, definitions, style: { textTransform: "uppercase" } },
        ...InputProps
      }}
      placeholder={placeholder}
      onChange={sendOnChange}
    />
  );
};

export default MaskedTextField;

export interface MacTextFieldProps extends BaseTextFieldProps {
  label?: string;
  mask?: string;
  definitions?: { [key: string]: RegExp };
  hiddenLabel?: boolean;
  placeholder?: string;
  onChange?: (value: string) => void;
  onBlur?: FocusEventHandler<HTMLTextAreaElement | HTMLInputElement>;
  InputProps?: Partial<FilledInputProps>
}

export const MacTextField = (props: MacTextFieldProps) => (
  <MaskedTextField {...props} mask="##-##-##-##-##-##" definitions={{ "#": /[0-9a-fA-F]/ }} placeholder="00-00-00-00-00-00" />
);
